import RouterLink from '@app/components/RouterLink';
import DevText from '@app/components/Text';
import { Card, Colors } from '@blueprintjs/core';
import React from 'react';
import {
    NotificationResource,
    SubscriptionResource,
    SubscriptionPauseScheduleCanceledActivityPayloadResource,
} from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import { Endpoints } from '@app/data/consts';
import moment from 'moment';
import NotificationTemplate from '../../../../NotificationTemplate';

export interface SubscriptionPauseScheduleCanceledNotificationProps {
    authorizedUserId: ID;
    notification: NotificationResource;
    subscription: SubscriptionResource | null;
    dismiss: () => Promise<void>;
}

type Props = SubscriptionPauseScheduleCanceledNotificationProps;

// TODO: output
const amountOfSecondsInDay = 86400;

const SubscriptionPauseScheduleCanceledNotification: React.FC<Props> = ({ notification, subscription, dismiss }) => {
    const renderContent = () => {
        if (!subscription) {
            // This is bad, subscription is NOT found, which should not happen
            return <DevText color={Colors.RED2}>Subscription was not found</DevText>;
        }

        const payload: SubscriptionPauseScheduleCanceledActivityPayloadResource | null = notification.activity.payload;
        if (!payload) {
            // This is bad, there should be payload, but for some reason it is not there
            return <DevText color={Colors.RED2}>Payload was not found</DevText>;
        }

        return (
            <div>
                <DevText running className="mb-1">
                    Pause schedule of{' '}
                    <RouterLink to={Endpoints.SUBSCRIPTION.replace(':subscriptionId', subscription.id)}>
                        subscription
                    </RouterLink>
                    , owned by{' '}
                    <RouterLink to={Endpoints.CLIENT_BILLING.replace(':clientId', subscription.user.id)}>
                        {subscription.user.first_name} {subscription.user.last_name}
                    </RouterLink>{' '}
                    was canceled. This usually happens because subscription was unexpectedly updated or canceled through
                    Stripe. Please check{' '}
                    <RouterLink to={Endpoints.SUBSCRIPTION.replace(':subscriptionId', subscription.id)}>
                        subscription page
                    </RouterLink>{' '}
                    to check its current state. Before cancelling pause schedule, it had following parameters:
                </DevText>

                <Card compact>
                    <DevText className="mb-small">
                        <DevText inline muted>
                            Resume at:
                        </DevText>{' '}
                        {moment(payload.previous_release_scheduled_at).format('D MMM YYYY, HH:mm')}
                    </DevText>
                    <DevText>
                        <DevText inline muted>
                            Add after resume:
                        </DevText>{' '}
                        {Math.round(payload.previous_unused_period / amountOfSecondsInDay)} days
                    </DevText>
                </Card>
            </div>
        );
    };

    return (
        <NotificationTemplate
            title="Subscription pause schedule was canceled"
            icon="cross-circle"
            at={notification.activity.at}
            content={renderContent()}
            dismiss={dismiss}
        />
    );
};

export default SubscriptionPauseScheduleCanceledNotification;
